module.exports = __webpack_public_path__ + "static/img/white-logo.0632dbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-logo.svg
// module id = 1998
// module chunks = 1